export const visit = (vm, at) => {
at({ "es": { "pricing-page-components": { "phone-support": { "seePhoneNumber": "Ver n\xFAmero de tel\xE9fono" } } } });
};